module.exports = __webpack_public_path__ + "img/cyber-security.e5bacc7d.jpg";